import src from "IMAGE";
export default { src, width: 398, height: 50, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAIAAABsYngUAAAAJElEQVR42mOYPXv2woUL582bt/bQ6dVnbm27dO/Rk6fPnz8HAM02EeD9DXM8AAAAAElFTkSuQmCC"};
